export enum DashboardType {
  TEAM_EVENT_PERFORMANCE = 'team_event_performance',
  TEAM_ADVANCED_PERFORMANCE = 'team_advanced_performance',
  TEAM_LOAD = 'team_load',
  TEAM_OVERVIEW = 'team_overview',

  PLAYER_EVENTS = 'player_events',
  PLAYER_PERFORMANCE = 'player_performance',
  PLAYER_LOAD = 'player_load',
  PLAYER_OVERVIEW = 'player_overview',

  PERIOD_SUMMARY = 'period_summary',
}
